import type Pageable from 'models/Pageable';
import type { ExtensionRequestDetailVO, ExtensionRequestDetailVOModel } from 'models/vo/ExtensionRequestDetailVO';
import { formattingToExtensionRequestDetailVOModel } from 'models/vo/ExtensionRequestDetailVO';
import type { ExtensionRequestVO, ExtensionRequestVOModel } from 'models/vo/ExtensionRequestVO';
import { formattingToExtensionRequestVOModel } from 'models/vo/ExtensionRequestVO';
import http from 'utils/http';
import API_FI from 'utils/http/api/financier';

import type { FinancierExtensionListRequest, FinancierExtensionRequest } from './request';

// 만기 연장 목록 조회
export async function requestFinancierExtensionList(
  pageNumber: number,
  rowCount: number,
  searchValue: FinancierExtensionListRequest,
): Promise<Pageable<ExtensionRequestVOModel[]>> {
  const response = await http.get<Pageable<ExtensionRequestVO[]>>({
    url: API_FI.EXTENSION_REQUESTS.EXTENSION_LIST,
    data: {
      pageNumber,
      rowCount,
      ...searchValue,
    },
  });
  const financierExtensionList: ExtensionRequestVOModel[] = response.content.map((data: ExtensionRequestVO) =>
    formattingToExtensionRequestVOModel(data),
  );
  const financierExtensionPage: Pageable<ExtensionRequestVOModel[]> = {
    ...response,
    content: financierExtensionList,
  };

  return financierExtensionPage;
}

// 만기 연장 상세 조회
export async function requestFinancierExtensionDetail(
  extensionRequestId: number,
): Promise<ExtensionRequestDetailVOModel> {
  const response = await http.get<ExtensionRequestDetailVO>({
    url: API_FI.EXTENSION_REQUESTS.EXTENSION_DETAIL(extensionRequestId),
  });

  return formattingToExtensionRequestDetailVOModel(response);
}

// FI :: /api/v1/fi/extension-requests/{extension-request-id}/return:loan-extension
// 만기연장 요청 반려
export async function requestFinancierReturnExtension(
  extensionRequestId: number,
  returnReason: string,
): Promise<ExtensionRequestDetailVOModel> {
  const response = await http.put<ExtensionRequestDetailVO>({
    url: API_FI.EXTENSION_REQUESTS.RETURN_EXTENSION(extensionRequestId),
    data: { returnReason },
  });

  return formattingToExtensionRequestDetailVOModel(response);
}

// FI :: /api/v1/fi/extension-requests/{extension-request-id}/approve:loan-extension
// 만기연장 승인 확정

export async function requestFinancierApproveExtension(
  extensionRequestId: number,
): Promise<ExtensionRequestDetailVOModel> {
  const response = await http.put<ExtensionRequestDetailVO>({
    url: API_FI.EXTENSION_REQUESTS.APPROVE_EXTENSION(extensionRequestId),
  });

  return formattingToExtensionRequestDetailVOModel(response);
}

// FI :: /api/v1/fi/extension-requests/{extension-request-id}/reject:loan-extension
// 만기연장 거절
export async function requestFinancierRejectExtension(
  extensionRequestId: number,
  rejectReason: string,
): Promise<ExtensionRequestDetailVOModel> {
  const response = await http.put<ExtensionRequestDetailVO>({
    url: API_FI.EXTENSION_REQUESTS.REJECT_EXTENSION(extensionRequestId),
    data: { rejectReason },
  });

  return formattingToExtensionRequestDetailVOModel(response);
}

// FI :: /api/v1/fi/extension-requests/{extension-request-id}/renew:loan-extension-by-financier-interface
// 만기연장 전문 업데이트
export async function requestFinancierRenewExtension(
  extensionRequestId: number,
): Promise<ExtensionRequestDetailVOModel> {
  const response = await http.put<ExtensionRequestDetailVO>({
    url: API_FI.EXTENSION_REQUESTS.RENEW_EXTENSION(extensionRequestId),
  });

  return formattingToExtensionRequestDetailVOModel(response);
}

// FI :: /api/v1/fi/extension-requests/{extension-request-id}/request:loan-extension
// 만기연장 승인 요청 operator -> authorizer
export async function requestFinancierConfirmExtension(
  extensionRequestId: number,
  data: FinancierExtensionRequest,
): Promise<ExtensionRequestDetailVOModel> {
  const response = await http.put<ExtensionRequestDetailVO>({
    url: API_FI.EXTENSION_REQUESTS.REQUEST_EXTENSION_CONFIRM(extensionRequestId),
    data,
  });

  return formattingToExtensionRequestDetailVOModel(response);
}
